module.exports = __webpack_public_path__ + "static/img/icon-excel-action.3a25400.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-excel-action.svg
// module id = 151
// module chunks = 1